import React from 'react';
import {WeaLocaleProvider, WeaSearchGroup} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import EType from './base/EType';
import ETitle from './base/ETitle';

// 自定义元素
export default class Content_CustomElement extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {hpid, eid, ebaseid, eCustom = {}, synergyParams = {}} = this.props;
        const {packagename, settingcompname} = eCustom;

        let ECustomSetting = null;
        if(window.rewritePortalCusEleSetting && typeof window.rewritePortalCusEleSetting == 'function') {
            const props = {...this.props};
            const options = {
              getInstance:(eCustomSetting) => this.eCustomSetting = eCustomSetting,
              id:eid,
              eid,
              ebaseid,
              params:{hpid, eid, ebaseid},
              synergyParams
            }
            ECustomSetting = window.rewritePortalCusEleSetting(props, options);
        }

        if (ECustomSetting == null && window[packagename] && window[packagename]['com'] && window[packagename]['com'][settingcompname]) {
            const ECustomSettingTemp = window[packagename]['com'][settingcompname];
            ECustomSetting = <ECustomSettingTemp getInstance={(eCustomSetting) => this.eCustomSetting = eCustomSetting} params={{hpid, eid, ebaseid}} synergyParams={synergyParams}/>;
        }

        return (
            <div>
                <WeaSearchGroup title={getLabel(81711, '基本信息')} needTigger={true} showGroup={true}>
                    <EType ref="eType" value={this.props.eBaseName}/>
                    {this.props.eShareLevel == '2' ? <ETitle ref="eTitle" eid={this.props.eid} value={this.props.eTitle} hasLink={false}/> : ''}
                </WeaSearchGroup>
                {
                    this.props.eShareLevel == '2' && (
                        <WeaSearchGroup title={getLabel(20885, '内容来源')} needTigger={true} showGroup={true}>
                            {ECustomSetting}
                        </WeaSearchGroup>
                    )
                }
            </div>
        );
    }

    getSaveValues() {
        const result = this.eCustomSetting && this.eCustomSetting.onSave();

        if (result === false) {
            return null;
        }

        return {
            eContentTitle: this.refs['eTitle'] ? this.refs['eTitle'].getSaveValues() : this.props.eTitle
        };
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/Content_CustomElement.js